import { useEffect } from "react";

/**
 * The old app styled `html`/`body` per page; the SPA toggles a class on
 * both instead (the login gradient is sized by the root element, so `html`
 * needs the class too).
 */
export function useBodyClass(name: string) {
  useEffect(() => {
    document.documentElement.classList.add(name);
    document.body.classList.add(name);
    return () => {
      document.documentElement.classList.remove(name);
      document.body.classList.remove(name);
    };
  }, [name]);
}
